import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const CreditorSchema = withDefaults({
  type: 'creditor',
  fields: [
    {
      kind: 'attribute',
      name: 'accountName',
    },
    {
      kind: 'attribute',
      name: 'accountNumber',
    },
    {
      kind: 'attribute',
      name: 'bankName',
    },
    {
      kind: 'attribute',
      name: 'isActive',
    },
    {
      kind: 'attribute',
      name: 'paymentAccountSetupType',
    },
    {
      kind: 'attribute',
      name: 'routingNumber',
    },
    {
      kind: 'attribute',
      name: 'checkNumber',
    },
    {
      kind: 'belongsTo',
      name: 'postalAddress',
      type: 'postal-address',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'belongsTo',
      name: 'billingAddress',
      type: 'postal-address',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'belongsTo',
      name: 'user',
      type: 'user',
      options: {
        async: false,
        inverse: null,
      },
    },
  ],
});

export default CreditorSchema;
